

import React, { memo, useState, useEffect } from 'react';

import { withSize } from 'react-sizeme';
import cx from 'classnames';
import { Text, Icon, Switch } from '../../../../../../ui-kit';
import { SMALL_SIZE } from '../../constants';


import '../../styles/_toggle-addon.scss';

















function ToggleValueAddon({
  id,
  title,
  subtitle,
  icon,
  costString,
  selected,
  onChange,
  withInfo = false,
  onInfoClick,
  disabled,
  size: { width },
  children,
  extraComponent
}) {
  const [toggleSelected, setToggleSelected] = useState(Boolean(selected));

  const handleChange = (value) => {
    setToggleSelected(value);
    onChange(value);
  };

  useEffect(() => {
    setToggleSelected(Boolean(selected));
  }, [selected]);

  const isMobile = width <= SMALL_SIZE;

  return (
    <div
      className={cx('toggle-addon', {
        'toggle-addon--small': isMobile
      })}>

      <div className="toggle-addon__wrapper">
        <div className="toggle-addon__main">
          <div>
            <div className="toggle-addon__col">
              <Icon className="toggle-addon__icon" name={icon} size={24} />

              <Text className="toggle-addon__title">{title}</Text>
            </div>

            {withInfo &&
            <div className="toggle-addon__col">
                <Icon
                className="toggle-addon__info"
                name="info"
                size={16}
                onClick={onInfoClick} />

              </div>}

          </div>

          {subtitle &&
          <Text className="toggle-addon__subtitle" timestamp>
              {subtitle}
            </Text>}

        </div>
        <div className="toggle-addon__cost-toggle">
          {costString &&
          <Text heading4 className="toggle-addon__cost">
              {costString || ''}
            </Text>}

          {extraComponent && extraComponent()}
          <Switch
            id={`${id}-toggle-switch`}
            onChange={handleChange}
            checked={toggleSelected}
            disabled={disabled} />

        </div>
      </div>
      {toggleSelected && children}
    </div>);

}

export default memo(withSize()(ToggleValueAddon));